import React, { useState } from 'react'
import './Home.css';
import { TextField } from '@material-ui/core';
import InputHome from './InputHome';
import validate from './validateInfo';
import MaterialTable from 'material-table';
import { Link } from '@material-ui/core';
import ajax from '../utility/ajax';
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from 'react-promise-tracker';


function Home() {
    const [id, setId] = useState([])
    const [data, setData] = useState([])
    const columns = [
        { title: "Customer Email", field: "email" },
        { title: "Customer ID", field: "id" },
        { title: "License Type", render: rowData => <>-</> },
        { title: "Action", render: rowData => <Link href={`details?customerKey=${rowData.id}&customerEmail=${rowData.email}`} target="_blank">View Details</Link> }
    ]
    
    const { promiseInProgress } = usePromiseTracker();

    async function callAPI(id) {
        setId(id);
        const axiosApp = await ajax();
        const data = { 'email': id }
       trackPromise(
        axiosApp.post('/api_service/customer_resource', data, { headers: { Authorization: "Bearer " +   localStorage.getItem('idToken') } }).then(response => {
            if (response.data.data.details.length === 0)
                alert("No result");
            if (response.data.error !== undefined)
                alert(response.data.error)
            else
                setData(response.data.data.details)
        }).catch(e => {
            alert("Failed: " + e.response.statusText)
        })
       );

    }

    const [searchTerm, setSearchTerm] = useState('');
    const { handleChange, values, handleSubmit, errors } = InputHome(validate);
    const [show, setShow] = useState(false);
    return (
        <div className='home'>
            &nbsp;
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
            />
            <form className='form' onSubmit={handleSubmit}>
                <TextField className="textip"
                    label="Customer ID / Email / Domain"
                    name="customerid"
                    color="secondary"
                    variant="filled"
                    style={{ width: '40%' }}
                    type="text"
                    value={values.customerid}
                    onChange={handleChange}
                />
                {errors.customerid && <p>{errors.customerid}</p>}
                <button className='searchBtn' type='submit' onClick={() => callAPI(values.customerid)} >Search</button>

                <hr className='hrcss' />
                    <div className="CustomerTable">{!promiseInProgress && 
                            <MaterialTable
                                title="Customer List"
                                data={data}
                                columns={columns}
                                options={{
                                    headerStyle: { position: 'sticky', top: 0 },
                                    search: false,
                                    paging: false,
                                    filtering: true
                                }}
                            />
                        }    
                    </div>
            </form>
        </div>
    );
}

export default Home;
